class PeriodFilter {
    constructor(options) {
        this.options = {};

        this.id = new Date().getUTCMilliseconds() + Math.random();
        this.wrapper = $('<div class="filter-wrapper"/>');
        this.button = $('<button type="button" class="filter period-filter"/>')
            .attr('tabindex', 0)
            .attr('aria-label', 'Periode')
            .attr('aria-controls', 'period-filter-' + this.id)
            .attr('aria-owns', 'period-filter-' + this.id)
            .on('click', this.onButtonClick.bind(this))
            .appendTo(this.wrapper);

        this.popover = $('<div class="popover hidden"/>')
            .appendTo(this.wrapper);

        this.popoverContent = $('<div class="content"/>')
            .appendTo(this.popover);

        this.accuracyInput = $('<select><option value="1">Rond</option><option value="2">Voor</option><option value="3">Na</option><option value="4">Tussen</option></select>')
            .appendTo(this.popoverContent)
            .on('change', this.onChange.bind(this))
            .segmentedSelect();

        this.yearMinInput = $('<input type="number" class="left"/>')
            .attr('placeholder', 'Jaartal')
            .attr('maxlength', 4)
            .attr('min', 0)
            .numericInput()
            .on('input', this.onChange.bind(this))
            .appendTo(this.popoverContent);

        this.yearMaxInput = $('<input type="number" class="right"/>')
            .attr('placeholder', 'Jaartal')
            .attr('maxlength', 4)
            .attr('min', 0)
            .on('input', this.onChange.bind(this))
            .numericInput()
            .appendTo(this.popoverContent);

        this.options = $.extend(this.options, options);

        this.updateContent();
        this.updateVisibility();
    }
    appendTo(element) {
        this.wrapper.appendTo(element);
        return this;
    }
    insertAfter(element) {
        this.wrapper.insertAfter(element);
        return this;
    }
    updateContent() {
        let yearMin = this.yearMin;
        let yearMax = this.yearMax;
        if (this.accuracy == 1 && yearMin) this.button.text('Rond ' + yearMin);
        else if (this.accuracy == 2 && yearMin) this.button.text('Voor ' + yearMin);
        else if (this.accuracy == 3 && yearMin) this.button.text('Na ' + yearMin);
        else if (this.accuracy == 4 && yearMin && yearMax) this.button.text(yearMin + ' - ' + yearMax);
        else this.button.text('Elke periode');

        this.yearMinInput.toggleClass('multiple', this.accuracy == 4);
        this.yearMaxInput.toggleClass('multiple', this.accuracy == 4);
        this.yearMaxInput.toggleClass('hidden', this.accuracy != 4);
    }
    updateVisibility() {
        this.button.attr('aria-expanded', this.isVisible ? 'true' : 'false');
        this.popover.attr('aria-hidden', this.isVisible ? 'false' : 'true');
    }
    toggle() {
        if (this.isVisible) this.hide();
        else this.show();
    }
    show() {
        this.wrapper.addClass('visible');
        if (this.hideTimer) clearTimeout(this.hideTimer);
        if (this.showTimer) clearTimeout(this.showTimer);

        if (!this.mouseDownHandler) this.mouseDownHandler = this.onMouseDown.bind(this);
        $(document).on('mousedown', this.mouseDownHandler);

        this.button.addClass('no-radius');
        this.popover.removeClass('hidden');
        this.updateVisibility();
        this.yearMinInput.focus();

        this.showTimer = setTimeout(function(){
            this.popover.css('max-height', this.popoverContent.height());
        }.bind(this), 10);
    }
    hide() {
        this.wrapper.removeClass('visible');
        if (this.hideTimer) clearTimeout(this.hideTimer);
        if (this.showTimer) clearTimeout(this.showTimer);

        if (this.mouseDownHandler) $(document).off('mousedown', this.mouseDownHandler);

        this.popover.css('max-height', false);
        this.updateVisibility();

        this.hideTimer = setTimeout(function(){
            this.button.removeClass('no-radius');
            this.popover.addClass('hidden');
        }.bind(this), 200);
    }
    reset() {
        this.yearMinInput.val('');
        this.yearMaxInput.val('');
        this.updateContent();
        if (this.options.onChange) this.options.onChange(this);
    }
    onButtonClick(event) {
        if (event.which === 1) {
            this.toggle();
        }
    }
    onMouseDown(event) {
        if (event.which === 1 && this.isVisible) {
            if (!$.contains(this.wrapper[0], event.target)) this.hide();
        }
    }
    onChange() {
        this.updateContent();
        if (this.options.onChange) this.options.onChange(this);
    }
    get isFiltered() {
        let value = parseInt(this.yearMinInput.val(), 10);
        return (value > 1000 && value < 2100);
    }
    get isVisible() {
        return this.wrapper.hasClass('visible');
    }
    get accuracy() {
        return this.accuracyInput.val();
    }
    get yearMin() {
        let value = parseInt(this.yearMinInput.val(), 10);
        if (value > 1000 && value < 2100) return value;
    }
    get yearMax() {
        let value = parseInt(this.yearMaxInput.val(), 10);
        if (this.accuracy == 4 && value > 1000 && value < 2100) return value;
    }
}
